import React from "react";
import { useState } from "react";
import { handleError, handleSuccess } from "../../../Utils";
import { accountDeletion } from "../../../ApiServices/ApiServices";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../provider/authProvider";

const AccountDeletion = ({ setIsVisible }) => {
  const [otp, setOtp] = useState("");
  const navigateTo = useNavigate();
  const { removeToken, getUserName } = useAuth();

  const handleDeleteAccount = async () => {
    try {
      const res = await accountDeletion(otp);
      handleSuccess(res?.message);
      setOtp("");
      setIsVisible(false);
      removeToken();
      navigateTo('/login');
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-sm p-6">
        <h2 className="text-xl font-semibold mb-2 text-center">
          Delete Account
        </h2>

        <p className="text-gray-700 text-sm mb-1 text-[17px]">
          An OTP has been sent to your registered email address.
        </p>

        <input
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          placeholder="Enter OTP"
          className="w-full border border-gray-300 rounded-lg px-4 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />

        <div className="flex justify-between space-x-4">
          <button
            onClick={() => setIsVisible(false)}
            className="px-4 py-2 rounded-lg bg-gray-300 hover:bg-gray-400 transition"
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition"
            onClick={handleDeleteAccount}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountDeletion;
